import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_exception_product",
  ref: "exceptionProductRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-750px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_mismatched_more_product_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-400" }, null, -1)
const _hoisted_7 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_10 = { class: "d-flex align-items-center mb-16" }
const _hoisted_11 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex-fill" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bolder" }, "Data exception"),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-gray-400 fw-bold" }, " This barcode is associated with multiple groups of information, please confirm manually ")
], -1)
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = { class: "flex-1" }
const _hoisted_15 = { class: "flex-1" }
const _hoisted_16 = { class: "d-flex align-items-center justify-content-end gap-2" }
const _hoisted_17 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "modal-footer align-items-center justify-content-end" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "svg-icon svg-icon-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("inspection.inspection")) + " ", 1),
                  _createElementVNode("span", null, "/ " + _toDisplayString(_ctx.t("inspection.missing")), 1)
                ]),
                _hoisted_6
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                ]),
                _hoisted_12
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "radio" }, null, 512), [
                [_vShow, 0]
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "product" }, null, 512), [
                [_vShow, 0]
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "number" }, null, 512), [
                [_vShow, 0]
              ]),
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.product, (item, index) => {
                  return (_openBlock(), _createElementBlock("label", {
                    class: "d-flex align-items-center py-5 border-bottom cursor-pointer",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_product_info, {
                        gallery: item.gallery,
                        name: item.name_en,
                        name_en: item.name_en,
                        source_link: '',
                        brand_id: item.__show.brand_id
                      }, null, 8, ["gallery", "name", "name_en", "brand_id"])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_sku_info, {
                        brand_article_no: item.brand_article_no,
                        color: item.original_color,
                        size: item.__show.size,
                        product_identifier_id: item.product_identifier_id
                      }, null, 8, ["brand_article_no", "color", "size", "product_identifier_id"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          name: "exception_product",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.radio) = $event)),
                          value: index
                        }, null, 8, _hoisted_18), [
                          [_vModelRadio, _ctx.formData.radio]
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.loading,
                class: "btn btn-lg btn-primary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, [
                _withDirectives(_createElementVNode("span", null, [
                  _createElementVNode("span", _hoisted_21, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                ], 512), [
                  [_vShow, !_ctx.loading]
                ]),
                _withDirectives(_createElementVNode("span", null, [
                  _hoisted_22,
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                ], 512), [
                  [_vShow, _ctx.loading]
                ])
              ], 8, _hoisted_20)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}